import { NavLink } from 'react-router-dom';
import type { ManifestTab } from '../config/manifest';

interface Props {
  groupId: string;
  slug: string;
  tabs: ManifestTab[];
  activeTabId: string;
  readingMinutes?: Record<string, number>;
}

export default function DocTabStrip({ groupId, slug, tabs, activeTabId, readingMinutes }: Props) {
  return (
    <div className="tabs" role="tablist" aria-label="Document sections">
      {tabs.map((tab) => {
        const isActive = tab.id === activeTabId;
        const mins = readingMinutes?.[tab.id];
        return (
          <NavLink
            key={tab.id}
            to={`/d/${groupId}/${slug}/${tab.id}`}
            role="tab"
            aria-selected={isActive}
            className={`tab${isActive ? ' tab--active' : ''}`}
            replace
          >
            <span>{tab.label}</span>
            {mins !== undefined && <span className="tab__time">{mins} min</span>}
          </NavLink>
        );
      })}
    </div>
  );
}
